
const rtl = (document.querySelector('html').getAttribute('dir') == 'rtl');
/**
 * Media Browser
 */
class MediaBrowser {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.slider = this.el.querySelector('[data-media-slider]');
    this.thumbs = this.el.querySelector('[data-media-thumbs]');
    this.initSlider();
    this.initThumbs();
  }
  initSlider() {
    this.prevArrow = document.querySelector('[data-media-pager][data-dir-prev]');
    this.nextArrow = document.querySelector('[data-media-pager][data-dir-next]');
    $(this.slider).slick({
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      autoplay: false,
      arrows: true,
      dots: false,
      prevArrow: this.prevArrow,
      nextArrow: this.nextArrow,
      rtl,
      asNavFor: this.thumbs
    });
  }
  initThumbs() {
    // $(this.thumbs).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    //   //slickVideos(slick, currentSlide, nextSlide);
    //   console.log(slick);
    // })
    // $(this.thumbs).on('afterChange', function(event, slick, currentSlide) {
    //   // state = currentSlide;
    //   // slide = slick.$slides[currentSlide];
    //   // slideTimeout();
    // })
    //
    // $(this.thumbs).on('init', function(event, slick){
    //   console.log(slick.$slides);
    //   slick.$slides.on('click', function() {
    //     console.log(this);
    //   })
    // })
    $(this.thumbs).slick({
      speed: 1000,
      infinite: false,
      autoplay: false,
      arrows: false,
      dots: false,
      slidesToShow: 9,
      slidesToScroll: 1,
      swipeToSlide: true,
      focusOnSelect: true,
      centerMode: false,
      rtl,
      asNavFor: this.slider,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

  }
}

export default function () {
  const browser = new MediaBrowser(document.querySelector('[data-media-browser]'));
}



// WEBPACK FOOTER //
// ./public/javascripts/modules/media-browser.js